import {
  realtime,
  axios
} from './api'

function createAXIOSObj(link, params) {
  let ax = axios.create({
    baseURL: link,
    timeout: params.timeout ? params.timeout : 120000,
    withCredentials: false,
    headers: {
      'Accept': params.accept ? params.accept : null,
      'Content-Type': params.contentType ? params.contentType : null
    }
  });

  if (params.bearer != null) {
    ax.defaults.headers.common['Authorization'] = `Bearer ${val}`;
  }

  return ax;
}

export default {
  config(token) {
    let val = (token != null) && (token.access_token != null) ? token.access_token : token;
    realtime.defaults.headers.common['Authorization'] = `Bearer ${val}`;
  },

  custom: {
    get(link, params) {
      let ax = createAXIOSObj(link, params);
      return ax.get('');
    },
    post(link, data, params) {
      let ax = createAXIOSObj(link, params);
      return ax.post('', data);
    },
    put(link, data, params) {
      let ax = createAXIOSObj(link, params);
      return ax.put('', data);
    },
    patch(link, data, params) {
      let ax = createAXIOSObj(link, params);
      return ax.patch('', data);
    },
    delete(link, data, params) {
      let ax = createAXIOSObj(link, params);
      return ax.delete('', data);
    }
  },

  trips: {
    get(uid) {
      let uri = uid != null ? `/trips/${uid.toString()}` : '/trips';
      return realtime.get(uri, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
    },
  },
}
